import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const WatchTowerQueryRuleRBAC = {
  pageID: '7899860524b3fb26f514df73b26503e9',
  elementID: {
    ViewPage: '47702baa76bb49a516249d8dd25d6c27',
    UpdateData: '648ef59f37439d6884284fdf067dce46',
    ChangeToggleStatus: 'fdac82d6ff5a85dfc221deb8ec01d25a',
    AddData: '71565377388850b0e15d0f2a15482782',
  },
} as const

export const useWatchTowerQueryRuleRBACPage = createUseRBAC(WatchTowerQueryRuleRBAC.elementID)

export type UseWatchTowerQueryRuleRBACPageType = ReturnType<typeof useWatchTowerQueryRuleRBACPage>
